export default __webpack_public_path__ + "static/media/icon_profile.df66ed63.svg";